import o from "./SVGs/addToFolder.svg.mjs";
import r from "./SVGs/addedtoFolder.svg.mjs";
import t from "./SVGs/aiWand.svg.mjs";
import e from "./SVGs/alarmBell.svg.mjs";
import i from "./SVGs/alignBottom.svg.mjs";
import n from "./SVGs/alignCenter.svg.mjs";
import l from "./SVGs/alignLeft.svg.mjs";
import m from "./SVGs/alignMiddle.svg.mjs";
import a from "./SVGs/alignRight.svg.mjs";
import c from "./SVGs/alignTop.svg.mjs";
import s from "./SVGs/amex.svg.mjs";
import p from "./SVGs/applePay.svg.mjs";
import g from "./SVGs/arrowBack.svg.mjs";
import S from "./SVGs/arrowCursor_blue.svg.mjs";
import f from "./SVGs/arrowCursor_pink.svg.mjs";
import v from "./SVGs/arrowCursor_yellow.svg.mjs";
import u from "./SVGs/arrowDown.svg.mjs";
import d from "./SVGs/arrowRight.svg.mjs";
import w from "./SVGs/arrowUp.svg.mjs";
import k from "./SVGs/attachment.svg.mjs";
import P from "./SVGs/audioModified.svg.mjs";
import B from "./SVGs/blankCalendar_blue.svg.mjs";
import C from "./SVGs/blankCalendar_pink.svg.mjs";
import h from "./SVGs/blankCalendar_yellow.svg.mjs";
import Y from "./SVGs/brain.svg.mjs";
import y from "./SVGs/businessStartup_blue.svg.mjs";
import b from "./SVGs/businessStartup_pink.svg.mjs";
import A from "./SVGs/businessStartup_yellow.svg.mjs";
import M from "./SVGs/calendar.svg.mjs";
import I from "./SVGs/cameraVideo_blue.svg.mjs";
import L from "./SVGs/cameraVideo_pink.svg.mjs";
import V from "./SVGs/cameraVideo_yellow.svg.mjs";
import T from "./SVGs/camera_blue.svg.mjs";
import F from "./SVGs/camera_pink.svg.mjs";
import H from "./SVGs/camera_yellow.svg.mjs";
import G from "./SVGs/chatBubbleTypingOval_blue.svg.mjs";
import E from "./SVGs/chatBubbleTypingOval_pink.svg.mjs";
import U from "./SVGs/chatBubbleTypingOval_yellow.svg.mjs";
import W from "./SVGs/chatTwoBubblesSquare_blue.svg.mjs";
import D from "./SVGs/chatTwoBubblesSquare_pink.svg.mjs";
import O from "./SVGs/chatTwoBubblesSquare_yellow.svg.mjs";
import R from "./SVGs/check.svg.mjs";
import x from "./SVGs/checkCircle.svg.mjs";
import q from "./SVGs/chevronDown.svg.mjs";
import N from "./SVGs/chevronLeft.svg.mjs";
import K from "./SVGs/chevronRight.svg.mjs";
import z from "./SVGs/chevronUp.svg.mjs";
import Q from "./SVGs/circleCheck.svg.mjs";
import Z from "./SVGs/circleClock_black.svg.mjs";
import j from "./SVGs/circleClock_blue.svg.mjs";
import J from "./SVGs/circleClock_pink.svg.mjs";
import X from "./SVGs/circleClock_yellow.svg.mjs";
import _ from "./SVGs/close.svg.mjs";
import $ from "./SVGs/cog.svg.mjs";
import oo from "./SVGs/compass.svg.mjs";
import ro from "./SVGs/controlsForward.svg.mjs";
import to from "./SVGs/controlsPause.svg.mjs";
import eo from "./SVGs/controlsPlay.svg.mjs";
import io from "./SVGs/controlsRecord.svg.mjs";
import no from "./SVGs/controlsRewind.svg.mjs";
import lo from "./SVGs/controlsStop.svg.mjs";
import mo from "./SVGs/dashboardGauge_blue.svg.mjs";
import ao from "./SVGs/dashboardGauge_pink.svg.mjs";
import co from "./SVGs/dashboardGauge_yellow.svg.mjs";
import so from "./SVGs/dinersClub.svg.mjs";
import po from "./SVGs/discover.svg.mjs";
import go from "./SVGs/downloadBottom.svg.mjs";
import So from "./SVGs/downloadSquare_blue.svg.mjs";
import fo from "./SVGs/downloadSquare_pink.svg.mjs";
import vo from "./SVGs/downloadSquare_yellow.svg.mjs";
import uo from "./SVGs/dropbox.svg.mjs";
import wo from "./SVGs/emptyClipboard_blue.svg.mjs";
import ko from "./SVGs/emptyClipboard_pink.svg.mjs";
import Po from "./SVGs/emptyClipboard_yellow.svg.mjs";
import Bo from "./SVGs/erlenmeyerFlask_blue.svg.mjs";
import Co from "./SVGs/erlenmeyerFlask_pink.svg.mjs";
import ho from "./SVGs/erlenmeyerFlask_yellow.svg.mjs";
import Yo from "./SVGs/error.svg.mjs";
import yo from "./SVGs/expandHorizontal.svg.mjs";
import bo from "./SVGs/expandVertical.svg.mjs";
import Ao from "./SVGs/facebook.svg.mjs";
import Mo from "./SVGs/favorite.svg.mjs";
import Io from "./SVGs/favoriteFilled.svg.mjs";
import Lo from "./SVGs/fileDouble.svg.mjs";
import Vo from "./SVGs/filter.svg.mjs";
import To from "./SVGs/filterImage.svg.mjs";
import Fo from "./SVGs/filterMusic.svg.mjs";
import Ho from "./SVGs/filterPlus.svg.mjs";
import Go from "./SVGs/filterVideo.svg.mjs";
import Eo from "./SVGs/folderStar.svg.mjs";
import Uo from "./SVGs/generateImage.svg.mjs";
import Wo from "./SVGs/generateVideo.svg.mjs";
import Do from "./SVGs/gitHub.svg.mjs";
import Oo from "./SVGs/googlePay.svg.mjs";
import Ro from "./SVGs/graphPieChart_blue.svg.mjs";
import xo from "./SVGs/graphPieChart_pink.svg.mjs";
import qo from "./SVGs/graphPieChart_yellow.svg.mjs";
import No from "./SVGs/gridRules_blue.svg.mjs";
import Ko from "./SVGs/gridRules_pink.svg.mjs";
import zo from "./SVGs/gridRules_yellow.svg.mjs";
import Qo from "./SVGs/happyFace_blue.svg.mjs";
import Zo from "./SVGs/happyFace_pink.svg.mjs";
import jo from "./SVGs/happyFace_yellow.svg.mjs";
import Jo from "./SVGs/headphonesCustomer.svg.mjs";
import Xo from "./SVGs/helpChat_blue.svg.mjs";
import _o from "./SVGs/helpChat_pink.svg.mjs";
import $o from "./SVGs/helpChat_yellow.svg.mjs";
import or from "./SVGs/home_blue.svg.mjs";
import rr from "./SVGs/home_pink.svg.mjs";
import tr from "./SVGs/home_yellow.svg.mjs";
import er from "./SVGs/hourGlass_blue.svg.mjs";
import ir from "./SVGs/hourGlass_pink.svg.mjs";
import nr from "./SVGs/hourGlass_yellow.svg.mjs";
import lr from "./SVGs/house.svg.mjs";
import mr from "./SVGs/image.svg.mjs";
import ar from "./SVGs/imageModified.svg.mjs";
import cr from "./SVGs/informationCircle.svg.mjs";
import sr from "./SVGs/informationCircleInverted.svg.mjs";
import pr from "./SVGs/instagram.svg.mjs";
import gr from "./SVGs/interfaceAlertAlarmBell_blue.svg.mjs";
import Sr from "./SVGs/interfaceAlertAlarmBell_pink.svg.mjs";
import fr from "./SVGs/interfaceAlertAlarmBell_yellow.svg.mjs";
import vr from "./SVGs/interfaceAwardTrophy_blue.svg.mjs";
import ur from "./SVGs/interfaceAwardTrophy_pink.svg.mjs";
import dr from "./SVGs/interfaceAwardTrophy_yellow.svg.mjs";
import wr from "./SVGs/interfaceCursorArrow_blue.svg.mjs";
import kr from "./SVGs/interfaceCursorArrow_pink.svg.mjs";
import Pr from "./SVGs/interfaceCursorArrow_yellow.svg.mjs";
import Br from "./SVGs/interfaceFavoriteLike_blue.svg.mjs";
import Cr from "./SVGs/interfaceFavoriteLike_pink.svg.mjs";
import hr from "./SVGs/interfaceFavoriteLike_yellow.svg.mjs";
import Yr from "./SVGs/interfaceImageVideoAudioSubtitles_blue.svg.mjs";
import yr from "./SVGs/interfaceImageVideoAudioSubtitles_pink.svg.mjs";
import br from "./SVGs/interfaceImageVideoAudioSubtitles_yellow.svg.mjs";
import Ar from "./SVGs/interfaceLightingLightBulb_blue.svg.mjs";
import Mr from "./SVGs/interfaceLightingLightBulb_pink.svg.mjs";
import Ir from "./SVGs/interfaceLightingLightBulb_yellow.svg.mjs";
import Lr from "./SVGs/interfaceSearch_blue.svg.mjs";
import Vr from "./SVGs/interfaceSearch_pink.svg.mjs";
import Tr from "./SVGs/interfaceSearch_yellow.svg.mjs";
import Fr from "./SVGs/keyboardArrowRight.svg.mjs";
import Hr from "./SVGs/keyboard_blue.svg.mjs";
import Gr from "./SVGs/keyboard_pink.svg.mjs";
import Er from "./SVGs/keyboard_yellow.svg.mjs";
import Ur from "./SVGs/layers_blue.svg.mjs";
import Wr from "./SVGs/layers_pink.svg.mjs";
import Dr from "./SVGs/layers_yellow.svg.mjs";
import Or from "./SVGs/layoutWindow_blue.svg.mjs";
import Rr from "./SVGs/layoutWindow_pink.svg.mjs";
import xr from "./SVGs/layoutWindow_yellow.svg.mjs";
import qr from "./SVGs/linkedIn.svg.mjs";
import Nr from "./SVGs/loadingRing.svg.mjs";
import Kr from "./SVGs/lock.svg.mjs";
import zr from "./SVGs/lockUnlock.svg.mjs";
import Qr from "./SVGs/login_blue.svg.mjs";
import Zr from "./SVGs/login_pink.svg.mjs";
import jr from "./SVGs/login_yellow.svg.mjs";
import Jr from "./SVGs/logoStoryblocks.svg.mjs";
import Xr from "./SVGs/logoStoryblocksGray.svg.mjs";
import _r from "./SVGs/logoStoryblocksWhite.svg.mjs";
import $r from "./SVGs/maestro.svg.mjs";
import ot from "./SVGs/magicWand_blue.svg.mjs";
import rt from "./SVGs/magicWand_pink.svg.mjs";
import tt from "./SVGs/magicWand_yellow.svg.mjs";
import et from "./SVGs/maker.svg.mjs";
import it from "./SVGs/mastercard.svg.mjs";
import nt from "./SVGs/meetingCamera.svg.mjs";
import lt from "./SVGs/megaphone_blue.svg.mjs";
import mt from "./SVGs/megaphone_pink.svg.mjs";
import at from "./SVGs/megaphone_yellow.svg.mjs";
import ct from "./SVGs/microphone.svg.mjs";
import st from "./SVGs/microphoneOff.svg.mjs";
import pt from "./SVGs/moneyCashBill_blue.svg.mjs";
import gt from "./SVGs/moneyCashBill_pink.svg.mjs";
import St from "./SVGs/moneyCashBill_yellow.svg.mjs";
import ft from "./SVGs/moneyWallet_blue.svg.mjs";
import vt from "./SVGs/moneyWallet_pink.svg.mjs";
import ut from "./SVGs/moneyWallet_yellow.svg.mjs";
import dt from "./SVGs/musicSound.svg.mjs";
import wt from "./SVGs/navigationMenuHorizontal.svg.mjs";
import kt from "./SVGs/navigationMenuVertical.svg.mjs";
import Pt from "./SVGs/newStickyNote_blue.svg.mjs";
import Bt from "./SVGs/newStickyNote_pink.svg.mjs";
import Ct from "./SVGs/newStickyNote_yellow.svg.mjs";
import ht from "./SVGs/oneFingerTap_blue.svg.mjs";
import Yt from "./SVGs/oneFingerTap_pink.svg.mjs";
import yt from "./SVGs/oneFingerTap_yellow.svg.mjs";
import bt from "./SVGs/openBook_blue.svg.mjs";
import At from "./SVGs/openBook_pink.svg.mjs";
import Mt from "./SVGs/openBook_yellow.svg.mjs";
import It from "./SVGs/panelCollapse.svg.mjs";
import Lt from "./SVGs/panelExpand.svg.mjs";
import Vt from "./SVGs/paragraphLeftAlign.svg.mjs";
import Tt from "./SVGs/paragraphsCenterAlign.svg.mjs";
import Ft from "./SVGs/paragraphsRightAlign.svg.mjs";
import Ht from "./SVGs/payPal.svg.mjs";
import Gt from "./SVGs/pen_blue.svg.mjs";
import Et from "./SVGs/pen_pink.svg.mjs";
import Ut from "./SVGs/pen_yellow.svg.mjs";
import Wt from "./SVGs/pencil.svg.mjs";
import Dt from "./SVGs/picturesFolderMemories_blue.svg.mjs";
import Ot from "./SVGs/picturesFolderMemories_pink.svg.mjs";
import Rt from "./SVGs/picturesFolderMemories_yellow.svg.mjs";
import xt from "./SVGs/pin_blue.svg.mjs";
import qt from "./SVGs/pin_pink.svg.mjs";
import Nt from "./SVGs/pin_yellow.svg.mjs";
import Kt from "./SVGs/pinterest.svg.mjs";
import zt from "./SVGs/playList_blue.svg.mjs";
import Qt from "./SVGs/playList_pink.svg.mjs";
import Zt from "./SVGs/playList_yellow.svg.mjs";
import jt from "./SVGs/playVideo.svg.mjs";
import Jt from "./SVGs/plus.svg.mjs";
import Xt from "./SVGs/profileAvatar.svg.mjs";
import _t from "./SVGs/questionmark.svg.mjs";
import $t from "./SVGs/refresh.svg.mjs";
import oe from "./SVGs/screenTv_blue.svg.mjs";
import re from "./SVGs/screenTv_pink.svg.mjs";
import te from "./SVGs/screenTv_yellow.svg.mjs";
import ee from "./SVGs/script_blue.svg.mjs";
import ie from "./SVGs/script_pink.svg.mjs";
import ne from "./SVGs/script_yellow.svg.mjs";
import le from "./SVGs/search.svg.mjs";
import me from "./SVGs/searchSimilar.svg.mjs";
import ae from "./SVGs/settingMenu.svg.mjs";
import ce from "./SVGs/share.svg.mjs";
import se from "./SVGs/shoppingCart_blue.svg.mjs";
import pe from "./SVGs/shoppingCart_pink.svg.mjs";
import ge from "./SVGs/shoppingCart_yellow.svg.mjs";
import Se from "./SVGs/snapchat.svg.mjs";
import fe from "./SVGs/sparkle.svg.mjs";
import ve from "./SVGs/sparkles.svg.mjs";
import ue from "./SVGs/stamp.svg.mjs";
import de from "./SVGs/starFourSided.svg.mjs";
import we from "./SVGs/stopwatch_blue.svg.mjs";
import ke from "./SVGs/stopwatch_pink.svg.mjs";
import Pe from "./SVGs/stopwatch_yellow.svg.mjs";
import Be from "./SVGs/stripe.svg.mjs";
import Ce from "./SVGs/sunCloud_blue.svg.mjs";
import he from "./SVGs/sunCloud_pink.svg.mjs";
import Ye from "./SVGs/sunCloud_yellow.svg.mjs";
import ye from "./SVGs/textBold.svg.mjs";
import be from "./SVGs/textInputArea.svg.mjs";
import Ae from "./SVGs/textItalic.svg.mjs";
import Me from "./SVGs/textStrikeThrough.svg.mjs";
import Ie from "./SVGs/textStyle.svg.mjs";
import Le from "./SVGs/textUnderline.svg.mjs";
import Ve from "./SVGs/thirdEye.svg.mjs";
import Te from "./SVGs/thumbDown.svg.mjs";
import Fe from "./SVGs/thumbUp.svg.mjs";
import He from "./SVGs/trash.svg.mjs";
import Ge from "./SVGs/travelMapEarth_blue.svg.mjs";
import Ee from "./SVGs/travelMapEarth_pink.svg.mjs";
import Ue from "./SVGs/travelMapEarth_yellow.svg.mjs";
import We from "./SVGs/twitter.svg.mjs";
import De from "./SVGs/uploadBottom.svg.mjs";
import Oe from "./SVGs/uploadCircle_blue.svg.mjs";
import Re from "./SVGs/uploadCircle_pink.svg.mjs";
import xe from "./SVGs/uploadCircle_yellow.svg.mjs";
import qe from "./SVGs/userCircleSingle_blue.svg.mjs";
import Ne from "./SVGs/userCircleSingle_pink.svg.mjs";
import Ke from "./SVGs/userCircleSingle_yellow.svg.mjs";
import ze from "./SVGs/userSingle_blue.svg.mjs";
import Qe from "./SVGs/userSingle_pink.svg.mjs";
import Ze from "./SVGs/userSingle_yellow.svg.mjs";
import je from "./SVGs/venmo.svg.mjs";
import Je from "./SVGs/verticalSliderSquare_blue.svg.mjs";
import Xe from "./SVGs/verticalSliderSquare_pink.svg.mjs";
import _e from "./SVGs/verticalSliderSquare_yellow.svg.mjs";
import $e from "./SVGs/videoEditPeel.svg.mjs";
import oi from "./SVGs/videoEditSplit.svg.mjs";
import ri from "./SVGs/videoModified.svg.mjs";
import ti from "./SVGs/view.svg.mjs";
import ei from "./SVGs/viewOff.svg.mjs";
import ii from "./SVGs/visa.svg.mjs";
import ni from "./SVGs/voiceMail_blue.svg.mjs";
import li from "./SVGs/voiceMail_pink.svg.mjs";
import mi from "./SVGs/voiceMail_yellow.svg.mjs";
import ai from "./SVGs/volumeDown.svg.mjs";
import ci from "./SVGs/volumeLevelHigh_blue.svg.mjs";
import si from "./SVGs/volumeLevelHigh_pink.svg.mjs";
import pi from "./SVGs/volumeLevelHigh_yellow.svg.mjs";
import gi from "./SVGs/volumeMedium.svg.mjs";
import Si from "./SVGs/volumeOff.svg.mjs";
import fi from "./SVGs/volumeUp.svg.mjs";
import vi from "./SVGs/warningTriangle.svg.mjs";
import ui from "./SVGs/waveform.svg.mjs";
import di from "./SVGs/webcamVideo_blue.svg.mjs";
import wi from "./SVGs/webcamVideo_pink.svg.mjs";
import ki from "./SVGs/webcamVideo_yellow.svg.mjs";
import Pi from "./SVGs/youtube.svg.mjs";
import Bi from "./SVGs/zap.svg.mjs";
const Nc = o, Kc = r, zc = t, Qc = e, Zc = i, jc = n, Jc = l, Xc = m, _c = a, $c = c, os = s, rs = p, ts = g, es = S, is = f, ns = v, ls = u, ms = d, as = w, cs = k, ss = P, ps = B, gs = C, Ss = h, fs = Y, vs = y, us = b, ds = A, ws = M, ks = T, Ps = F, Bs = H, Cs = I, hs = L, Ys = V, ys = G, bs = E, As = U, Ms = W, Is = D, Ls = O, Vs = R, Ts = x, Fs = q, Hs = N, Gs = K, Es = z, Us = Q, Ws = Z, Ds = j, Os = J, Rs = X, xs = _, qs = $, Ns = oo, Ks = ro, zs = to, Qs = eo, Zs = io, js = no, Js = lo, Xs = mo, _s = ao, $s = co, op = so, rp = po, tp = go, ep = So, ip = fo, np = vo, lp = uo, mp = wo, ap = ko, cp = Po, sp = Bo, pp = Co, gp = ho, Sp = Yo, fp = yo, vp = bo, up = Ao, dp = Mo, wp = Io, kp = Lo, Pp = Vo, Bp = To, Cp = Fo, hp = Ho, Yp = Go, yp = Eo, bp = Uo, Ap = Wo, Mp = Do, Ip = Oo, Lp = Ro, Vp = xo, Tp = qo, Fp = No, Hp = Ko, Gp = zo, Ep = Qo, Up = Zo, Wp = jo, Dp = Jo, Op = Xo, Rp = _o, xp = $o, qp = or, Np = rr, Kp = tr, zp = er, Qp = ir, Zp = nr, jp = lr, Jp = mr, Xp = ar, _p = cr, $p = sr, og = pr, rg = gr, tg = Sr, eg = fr, ig = vr, ng = ur, lg = dr, mg = wr, ag = kr, cg = Pr, sg = Br, pg = Cr, gg = hr, Sg = Yr, fg = yr, vg = br, ug = Ar, dg = Mr, wg = Ir, kg = Lr, Pg = Vr, Bg = Tr, Cg = Hr, hg = Gr, Yg = Er, yg = Fr, bg = Ur, Ag = Wr, Mg = Dr, Ig = Or, Lg = Rr, Vg = xr, Tg = qr, Fg = Nr, Hg = Kr, Gg = zr, Eg = Qr, Ug = Zr, Wg = jr, Dg = Jr, Og = Xr, Rg = _r, xg = $r, qg = ot, Ng = rt, Kg = tt, zg = et, Qg = it, Zg = nt, jg = lt, Jg = mt, Xg = at, _g = ct, $g = st, oS = pt, rS = gt, tS = St, eS = ft, iS = vt, nS = ut, lS = dt, mS = wt, aS = kt, cS = Pt, sS = Bt, pS = Ct, gS = ht, SS = Yt, fS = yt, vS = bt, uS = At, dS = Mt, wS = It, kS = Lt, PS = Vt, BS = Tt, CS = Ft, hS = Ht, YS = Gt, yS = Et, bS = Ut, AS = Wt, MS = Dt, IS = Ot, LS = Rt, VS = xt, TS = qt, FS = Nt, HS = Kt, GS = zt, ES = Qt, US = Zt, WS = jt, DS = Jt, OS = Xt, RS = _t, xS = $t, qS = oe, NS = re, KS = te, zS = ee, QS = ie, ZS = ne, jS = le, JS = me, XS = ae, _S = ce, $S = se, of = pe, rf = ge, tf = Se, ef = fe, nf = ve, lf = ue, mf = de, af = we, cf = ke, sf = Pe, pf = Be, gf = Ce, Sf = he, ff = Ye, vf = ye, uf = be, df = Ae, wf = Me, kf = Ie, Pf = Le, Bf = Ve, Cf = Te, hf = Fe, Yf = He, yf = Ge, bf = Ee, Af = Ue, Mf = We, If = De, Lf = Oe, Vf = Re, Tf = xe, Ff = qe, Hf = Ne, Gf = Ke, Ef = ze, Uf = Qe, Wf = Ze, Df = je, Of = Je, Rf = Xe, xf = _e, qf = $e, Nf = oi, Kf = ri, zf = ti, Qf = ei, Zf = ii, jf = ni, Jf = li, Xf = mi, _f = ai, $f = ci, ov = si, rv = pi, tv = gi, ev = Si, iv = fi, nv = vi, lv = ui, mv = di, av = wi, cv = ki, sv = Pi, pv = Bi;
export {
  Nc as AddToFolder,
  Kc as AddedtoFolder,
  zc as AiWand,
  Qc as AlarmBell,
  Zc as AlignBottom,
  jc as AlignCenter,
  Jc as AlignLeft,
  Xc as AlignMiddle,
  _c as AlignRight,
  $c as AlignTop,
  os as Amex,
  rs as ApplePay,
  ts as ArrowBack,
  es as ArrowCursorBlue,
  is as ArrowCursorPink,
  ns as ArrowCursorYellow,
  ls as ArrowDown,
  ms as ArrowRight,
  as as ArrowUp,
  cs as Attachment,
  ss as AudioModified,
  ps as BlankCalendarBlue,
  gs as BlankCalendarPink,
  Ss as BlankCalendarYellow,
  fs as Brain,
  vs as BusinessStartupBlue,
  us as BusinessStartupPink,
  ds as BusinessStartupYellow,
  ws as Calendar,
  ks as CameraBlue,
  Ps as CameraPink,
  Cs as CameraVideoBlue,
  hs as CameraVideoPink,
  Ys as CameraVideoYellow,
  Bs as CameraYellow,
  ys as ChatBubbleTypingOvalBlue,
  bs as ChatBubbleTypingOvalPink,
  As as ChatBubbleTypingOvalYellow,
  Ms as ChatTwoBubblesSquareBlue,
  Is as ChatTwoBubblesSquarePink,
  Ls as ChatTwoBubblesSquareYellow,
  Vs as Check,
  Ts as CheckCircle,
  Fs as ChevronDown,
  Hs as ChevronLeft,
  Gs as ChevronRight,
  Es as ChevronUp,
  Us as CircleCheck,
  Ws as CircleClockBlack,
  Ds as CircleClockBlue,
  Os as CircleClockPink,
  Rs as CircleClockYellow,
  xs as Close,
  qs as Cog,
  Ns as Compass,
  Ks as ControlsForward,
  zs as ControlsPause,
  Qs as ControlsPlay,
  Zs as ControlsRecord,
  js as ControlsRewind,
  Js as ControlsStop,
  Xs as DashboardGaugeBlue,
  _s as DashboardGaugePink,
  $s as DashboardGaugeYellow,
  op as DinersClub,
  rp as Discover,
  tp as DownloadBottom,
  ep as DownloadSquareBlue,
  ip as DownloadSquarePink,
  np as DownloadSquareYellow,
  lp as Dropbox,
  mp as EmptyClipboardBlue,
  ap as EmptyClipboardPink,
  cp as EmptyClipboardYellow,
  sp as ErlenmeyerFlaskBlue,
  pp as ErlenmeyerFlaskPink,
  gp as ErlenmeyerFlaskYellow,
  Sp as Error,
  fp as ExpandHorizontal,
  vp as ExpandVertical,
  up as Facebook,
  dp as Favorite,
  wp as FavoriteFilled,
  kp as FileDouble,
  Pp as Filter,
  Bp as FilterImage,
  Cp as FilterMusic,
  hp as FilterPlus,
  Yp as FilterVideo,
  yp as FolderStar,
  bp as GenerateImage,
  Ap as GenerateVideo,
  Mp as GitHub,
  Ip as GooglePay,
  Lp as GraphPieChartBlue,
  Vp as GraphPieChartPink,
  Tp as GraphPieChartYellow,
  Fp as GridRulesBlue,
  Hp as GridRulesPink,
  Gp as GridRulesYellow,
  Ep as HappyFaceBlue,
  Up as HappyFacePink,
  Wp as HappyFaceYellow,
  Dp as HeadphonesCustomer,
  Op as HelpChatBlue,
  Rp as HelpChatPink,
  xp as HelpChatYellow,
  qp as HomeBlue,
  Np as HomePink,
  Kp as HomeYellow,
  zp as HourGlassBlue,
  Qp as HourGlassPink,
  Zp as HourGlassYellow,
  jp as House,
  Jp as Image,
  Xp as ImageModified,
  _p as InformationCircle,
  $p as InformationCircleInverted,
  og as Instagram,
  rg as InterfaceAlertAlarmBellBlue,
  tg as InterfaceAlertAlarmBellPink,
  eg as InterfaceAlertAlarmBellYellow,
  ig as InterfaceAwardTrophyBlue,
  ng as InterfaceAwardTrophyPink,
  lg as InterfaceAwardTrophyYellow,
  mg as InterfaceCursorArrowBlue,
  ag as InterfaceCursorArrowPink,
  cg as InterfaceCursorArrowYellow,
  sg as InterfaceFavoriteLikeBlue,
  pg as InterfaceFavoriteLikePink,
  gg as InterfaceFavoriteLikeYellow,
  Sg as InterfaceImageVideoAudioSubtitlesBlue,
  fg as InterfaceImageVideoAudioSubtitlesPink,
  vg as InterfaceImageVideoAudioSubtitlesYellow,
  ug as InterfaceLightingLightBulbBlue,
  dg as InterfaceLightingLightBulbPink,
  wg as InterfaceLightingLightBulbYellow,
  kg as InterfaceSearchBlue,
  Pg as InterfaceSearchPink,
  Bg as InterfaceSearchYellow,
  yg as KeyboardArrowRight,
  Cg as KeyboardBlue,
  hg as KeyboardPink,
  Yg as KeyboardYellow,
  bg as LayersBlue,
  Ag as LayersPink,
  Mg as LayersYellow,
  Ig as LayoutWindowBlue,
  Lg as LayoutWindowPink,
  Vg as LayoutWindowYellow,
  Tg as LinkedIn,
  Fg as LoadingRing,
  Hg as Lock,
  Gg as LockUnlock,
  Eg as LoginBlue,
  Ug as LoginPink,
  Wg as LoginYellow,
  Dg as LogoStoryblocks,
  Og as LogoStoryblocksGray,
  Rg as LogoStoryblocksWhite,
  xg as Maestro,
  qg as MagicWandBlue,
  Ng as MagicWandPink,
  Kg as MagicWandYellow,
  zg as Maker,
  Qg as Mastercard,
  Zg as MeetingCamera,
  jg as MegaphoneBlue,
  Jg as MegaphonePink,
  Xg as MegaphoneYellow,
  _g as Microphone,
  $g as MicrophoneOff,
  oS as MoneyCashBillBlue,
  rS as MoneyCashBillPink,
  tS as MoneyCashBillYellow,
  eS as MoneyWalletBlue,
  iS as MoneyWalletPink,
  nS as MoneyWalletYellow,
  lS as MusicSound,
  mS as NavigationMenuHorizontal,
  aS as NavigationMenuVertical,
  cS as NewStickyNoteBlue,
  sS as NewStickyNotePink,
  pS as NewStickyNoteYellow,
  gS as OneFingerTapBlue,
  SS as OneFingerTapPink,
  fS as OneFingerTapYellow,
  vS as OpenBookBlue,
  uS as OpenBookPink,
  dS as OpenBookYellow,
  wS as PanelCollapse,
  kS as PanelExpand,
  PS as ParagraphLeftAlign,
  BS as ParagraphsCenterAlign,
  CS as ParagraphsRightAlign,
  hS as PayPal,
  YS as PenBlue,
  yS as PenPink,
  bS as PenYellow,
  AS as Pencil,
  MS as PicturesFolderMemoriesBlue,
  IS as PicturesFolderMemoriesPink,
  LS as PicturesFolderMemoriesYellow,
  VS as PinBlue,
  TS as PinPink,
  FS as PinYellow,
  HS as Pinterest,
  GS as PlayListBlue,
  ES as PlayListPink,
  US as PlayListYellow,
  WS as PlayVideo,
  DS as Plus,
  OS as ProfileAvatar,
  RS as Questionmark,
  xS as Refresh,
  qS as ScreenTvBlue,
  NS as ScreenTvPink,
  KS as ScreenTvYellow,
  zS as ScriptBlue,
  QS as ScriptPink,
  ZS as ScriptYellow,
  jS as Search,
  JS as SearchSimilar,
  XS as SettingMenu,
  _S as Share,
  $S as ShoppingCartBlue,
  of as ShoppingCartPink,
  rf as ShoppingCartYellow,
  tf as Snapchat,
  ef as Sparkle,
  nf as Sparkles,
  lf as Stamp,
  mf as StarFourSided,
  af as StopwatchBlue,
  cf as StopwatchPink,
  sf as StopwatchYellow,
  pf as Stripe,
  gf as SunCloudBlue,
  Sf as SunCloudPink,
  ff as SunCloudYellow,
  vf as TextBold,
  uf as TextInputArea,
  df as TextItalic,
  wf as TextStrikeThrough,
  kf as TextStyle,
  Pf as TextUnderline,
  Bf as ThirdEye,
  Cf as ThumbDown,
  hf as ThumbUp,
  Yf as Trash,
  yf as TravelMapEarthBlue,
  bf as TravelMapEarthPink,
  Af as TravelMapEarthYellow,
  Mf as Twitter,
  If as UploadBottom,
  Lf as UploadCircleBlue,
  Vf as UploadCirclePink,
  Tf as UploadCircleYellow,
  Ff as UserCircleSingleBlue,
  Hf as UserCircleSinglePink,
  Gf as UserCircleSingleYellow,
  Ef as UserSingleBlue,
  Uf as UserSinglePink,
  Wf as UserSingleYellow,
  Df as Venmo,
  Of as VerticalSliderSquareBlue,
  Rf as VerticalSliderSquarePink,
  xf as VerticalSliderSquareYellow,
  qf as VideoEditPeel,
  Nf as VideoEditSplit,
  Kf as VideoModified,
  zf as View,
  Qf as ViewOff,
  Zf as Visa,
  jf as VoiceMailBlue,
  Jf as VoiceMailPink,
  Xf as VoiceMailYellow,
  _f as VolumeDown,
  $f as VolumeLevelHighBlue,
  ov as VolumeLevelHighPink,
  rv as VolumeLevelHighYellow,
  tv as VolumeMedium,
  ev as VolumeOff,
  iv as VolumeUp,
  nv as WarningTriangle,
  lv as Waveform,
  mv as WebcamVideoBlue,
  av as WebcamVideoPink,
  cv as WebcamVideoYellow,
  sv as Youtube,
  pv as Zap
};
